import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { VISITOR_REPORT_API, MARK_REQUEST_SENT_API } from '../utils/api';
import Navbar from '../components/Navbar';

function VisitorReport() {
  const [visitors, setVisitors] = useState([]);
  const [search, setSearch] = useState('');
  const token = localStorage.getItem('token');
  const decoded = JSON.parse(atob(token));
  const customer_id = decoded.customer_id;

  useEffect(() => {
    fetchVisitors();
  }, []);

  const fetchVisitors = async () => {
    try {
      const res = await axios.post(
        VISITOR_REPORT_API,
        { token, customer_id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        setVisitors(res.data.visitors);
      } else {
        toast.error(res.data.message || 'Failed to fetch visitors');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error loading visitor report');
    }
  };

  const handleSendRequest = async (visitor_id) => {
    try {
      const res = await axios.post(
        MARK_REQUEST_SENT_API,
        { visitor_id, token },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        toast.success('Request Sent');
        fetchVisitors(); // Reload after update
      } else {
        toast.error(res.data.message || 'Failed to send request');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error sending request');
    }
  };
const handlePrintGatePass = (visitor_id, created_at) => {
  const encodedTimestamp = encodeURIComponent(created_at);
  window.open(`/gatepass/print/${visitor_id}/${encodedTimestamp}`, '_blank');
};


  const filteredVisitors = visitors.filter(
    (v) =>
      v.name.toLowerCase().includes(search.toLowerCase()) ||
      v.mobile.includes(search)
  );

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h3 className="mb-3">📄 Visitor Report</h3>

        <div className="mb-3">
          <input
            type="text"
            placeholder="Search by name or mobile"
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-hover table-sm">
            <thead className="table-light">
              <tr>
                <th>Photo</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Sex</th>
                <th>Company</th>
                <th>Purpose</th>
                <th>Whom to Visit</th>
                <th>Department</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredVisitors.length > 0 ? (
                filteredVisitors.map((v, i) => (
                  <tr key={i}>
                    <td>
                    {v.visitor_photo ? (
  <img
    src={`data:image/jpeg;base64,${v.visitor_photo}`}
    alt="Visitor"
    width={150}
    height={150}
    style={{ objectFit: 'cover' }}
  />
) : (
  'No Photo'
)}

                    </td>
                    <td>{v.name}</td>
                    <td>{v.mobile}</td>
                    <td>{v.sex}</td>
                    <td>
                      {v.company}
                      <br />
                      {v.city}
                    </td>
                    <td>{v.visit_purpose_name || v.purpose}</td>
                    <td>
                      {v.whom_to_visit_name
                        ? `${v.whom_to_visit_name} (${v.whom_to_visit_mobile})`
                        : '-'}
                    </td>
                    <td>{v.department_name || '-'}</td>
                    <td>{v.created_at}</td>
                    <td>
                      {v.request_sent === 0 ? (
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() => handleSendRequest(v.id)}
                        >
                          📤 Send Request
                        </button>
                      ) : v.request_approved === 0 ? (
                        <span className="badge bg-info text-dark">⏳ Pending Approval</span>
                      ) : (
                        <button
                          className="btn btn-sm btn-secondary"
                          onClick={() => handlePrintGatePass(v.id, v.created_at)}
                        >
                          🖨️ Print GatePass
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default VisitorReport;
